/**
 * Enum representing the payment providers.
 * This helps in standardizing payment providers across the application.
 */
export enum PaymentProvider {
    /**
     * PhonePe payment provider
     */
    PHONEPE = 'Phonepe',
    /**
     * BoxPay payment provider
     */
    BOXPAY = 'Boxpay',
    /**
     * Razorpay payment provider
     */
    RAZORPAY = 'Razorpay'
}